import { FC, useState } from "react";
import { Alert, Box, Tab, Tabs, Typography } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useCurrentUser } from "../../hooks/useCurrentUser";
import { isDashboardUser } from "../../api/dashboard";
import { LettingDashboard } from "./LettingDashboard";
import { ExpiryDashboard } from "./ExpiryDashboard";

export const Dashboard: FC = () => {
	const [user] = useCurrentUser();
	const [tab, setTab] = useState<"letting" | "expiry">("letting");

	if (!isDashboardUser(user?.groups, user?.admin)) {
		return (
			<Box sx={{ p: "60px 50px" }}>
				<Alert severity="error">The dashboard is only available to Admin, RSU, NRU and CRU users.</Alert>
			</Box>
		);
	}

	return (
		<LocalizationProvider dateAdapter={AdapterDayjs}>
			<Box sx={{ p: "60px 50px 50px", background: "rgb(250, 251, 252)", minHeight: "100%", boxSizing: "border-box" }}>
				<Typography fontSize={24} fontWeight={700} sx={{ mb: 2 }}>
					Dashboard
				</Typography>
				<Tabs value={tab} onChange={(_, value) => setTab(value)} sx={{ mb: 3 }}>
					<Tab value="letting" label="Letting / Target Completion Dates" />
					<Tab value="expiry" label="Expirations" />
				</Tabs>
				{tab === "letting" ? <LettingDashboard /> : <ExpiryDashboard />}
			</Box>
		</LocalizationProvider>
	);
};